import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://mentorly-api-y335r.ondigitalocean.app/'
  // baseURL: 'http://localhost:8000'
});

export default axiosInstance;
